import { useMutation } from "@tanstack/react-query";
import { useCallback } from "react";
import { useAuth0 } from "@auth0/auth0-react";

import {
  DeletePowerCurtail,
  PostAutoTuneV2Config,
  PostPowerCurtail,
} from "../../api/api";

type ManualPowerCurtailNowResult = {
  status: string;
  msg?: string;
};

type DeletePowerCurtailProps = {
  siteName: string;
  id: string;
  deleteType?: string; // Optional, if you want to delete a specific event
};

export const useDeletePowerCurtail = () => {
  const { getAccessTokenSilently } = useAuth0();

  const mutation = useMutation({
    mutationFn: ({
      token,
      ...params
    }: DeletePowerCurtailProps & {
      token: string;
    }): Promise<ManualPowerCurtailNowResult> =>
      DeletePowerCurtail(token, {
        ...params,
      }),

    onSuccess: (data) => {},

    onError: (error) => {
      console.error(
        "Error performing miner operations:",
        error
      );
    },
  });

  const mutateWithToken = useCallback(
    async (
      { ...params }: DeletePowerCurtailProps,
      options?: {
        onSuccess?: (
          data: ManualPowerCurtailNowResult
        ) => void;
        onError?: (error: any) => void;
        onSettled?: () => void;
      }
    ) => {
      const token = await getAccessTokenSilently();
      mutation.mutate(
        {
          ...params,
          token,
          // Ensure this is included
        },
        {
          onSuccess: options?.onSuccess,
          onError: options?.onError,
          onSettled: options?.onSettled,
        }
      );
    },
    [getAccessTokenSilently, mutation]
  );

  return { ...mutation, mutate: mutateWithToken };
};
